
import { useMemo } from "react";

import { AXNUIFormHelpTextContainer } from "@iddataweb/idw-common-ui/containers";
import { ThemingGenericContentSlotTypes } from "@iddataweb/idw-common-ui/enums";
import { AXNUIContent, AXNUILayout, AXNUITheme } from "@iddataweb/idw-common-ui/types";
import { getAXNUILayoutHelpTextParameters } from "@iddataweb/idw-common-ui/utils";

type AXNUIThemingPostSubmitHelpTextContainerProps = {
    axnuiContent: AXNUIContent;
    axnuiLayout: AXNUILayout;
    axnuiTheme: AXNUITheme;
};

export const AXNUIThemingPostSubmitHelpTextContainer = (props: AXNUIThemingPostSubmitHelpTextContainerProps) => {
    const { axnuiContent, axnuiLayout, axnuiTheme } = props;

    const helpTextParameters = useMemo(()=> {
        return getAXNUILayoutHelpTextParameters(axnuiContent, axnuiLayout, ThemingGenericContentSlotTypes.POST_SUBMIT_BUTTON_HELP_TEXT);
   }, [axnuiLayout.helpText.postSubmitButtonFormHelpText, axnuiContent]);
   
    return (
        <AXNUIFormHelpTextContainer
            parameters={helpTextParameters}
            id={ThemingGenericContentSlotTypes.POST_SUBMIT_BUTTON_HELP_TEXT}
            content={axnuiContent}
            explicitConsentChecked={false}
            isSubmitting={false}
            setExplicitConsentChecked={() => {}}
            textColor={axnuiTheme.general.mainTextColor}
            fontFamily={axnuiTheme.general.font}
            buttonTextColor={axnuiTheme.general.mainButtonTextColor}
            buttonBackgroundColor={axnuiTheme.general.mainButtonBackgroundColor}
            linksColor={axnuiTheme.general.linksColor}
        />
    );
};